<template>
  <svg class="icon-check" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.4304 4.5L6.75005 12.1803L3.56981 9.00008H1.44849L5.68939 13.241C6.27517 13.8268 7.22492 13.8268 7.81071 13.241L16.5517 4.5H14.4304Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'CalendarCheckIcon',
})
</script>

<style scoped lang="scss">
.icon-check {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
